/**
 * Edited by libaiqi on 2018/10/24.
 * Created by xiehan on 2017/05/19.
 */

import Logic from '../logic-base'

const alarmStrategyBiz = new Logic()

alarmStrategyBiz.deleteStrategy = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteStrategy,
    data: data
  })
}

alarmStrategyBiz.changeStrategy = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.changeStrategy,
    data: data
  })
}

alarmStrategyBiz.addStrategy = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addStrategy,
    data: data
  })
}

alarmStrategyBiz.findAll = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getStrategy,
    data: data
  })
}

alarmStrategyBiz.findAlarmStrategyId = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.findStrategyId,
    data: data
  })
}

export default alarmStrategyBiz
